import React from 'react'
import { Box, Typography, Button } from '@mui/joy'

import { VBox } from './VBox'
import { Check, Circle } from '@phosphor-icons/react'

import i18n from '@/i18n'

export function PlanCard({
    name,
    price,
    primary=false,
    recommended=false,
    features,
    description,
    recurring,
    yearlyRenewalFee,
    subscription,
    quoteOnly=false,
    onSubscribeClick,
    subscribing=false,
    onContactUsClick,
    onCancelClick
}) {
    const handleCancelClick = event => {
        onCancelClick(event)
    }
    const handleSubscribeClick = (event) => {
        onSubscribeClick(event)
    }

    const handleContactUsClick = () => {
        onContactUsClick(event)
    }

    return (
        <VBox sx={{ height: '100%', border: '2pt solid black', gap: 1, p: 2 }}>
            <Typography level="h2">{name}</Typography>
            <Typography level="h1" element="h1">{(price / 100).toLocaleString('en-US', { style: 'currency', currency: 'eur', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</Typography>
            <Typography style={{ visibility: recurring ? 'visible' : 'hidden' }}>+ {recurring ? <>€100 {i18n.t(recurring.interval)}</>: null}</Typography>
            <Typography>{description}</Typography>
            <ul>
                {features.map((feature, i) => (
                    <li key={feature.id} style={{ opacity: true ? 1 : 0.2 }}>
                        
                        <Typography>{true ? <Check /> : <Circle />} {feature.name}</Typography>    
                    </li>
                ))}
            </ul>
            <Box sx={{ flex: 1 }} />
            {subscription ? (
                subscription.cancelled ? (
                    <Button
                        variant="outlined"
                        color="primary"
                        disabled
                    >
                        {i18n.t('canceled')}
                    </Button>
                ) : (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleCancelClick}
                    >
                        {i18n.t('cancel-plan')}
                    </Button>
                )
            ) : (
                quoteOnly ? (
                    <Button
                        variant={primary ? "contained" : "outlined"}
                        color="primary"
                        onClick={handleContactUsClick}
                        disabled={subscription}
                    >
                        {i18n.t('contact-us')}
                    </Button>
                ) : (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleSubscribeClick}
                        disabled={subscription}
                        loading={subscribing}
                    >
                        {i18n.t(subscription ? 'current-plan' : 'subscribe')}
                    </Button>
                )
            )}
            {subscription?.expires && (
                <Typography>{i18n.t('expires-on', { date: new Date(subscription.expires).toLocaleDateString() })}</Typography>
            )}
            
        </VBox>
    )
}